import { Fragment } from 'react';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '../ui';

import { TBreadcrumb } from './types';

interface IBreadCrumbListItemProps {
  item: TBreadcrumb;
}

function BreadCrumbListItem({ item }: IBreadCrumbListItemProps) {
  const { label } = item;

  switch (item.type) {
    case 'action': {
      return (
        <BreadcrumbItem className="flex shrink-0">
          <BreadcrumbLink onClick={item.onClick}>{label}</BreadcrumbLink>
        </BreadcrumbItem>
      );
    }
    case 'link': {
      return (
        <BreadcrumbItem className="flex shrink-0">
          <BreadcrumbLink href={item.href}>{label}</BreadcrumbLink>
        </BreadcrumbItem>
      );
    }
    case 'page':
    default: {
      return (
        <BreadcrumbItem className="flex shrink-0">
          <BreadcrumbPage>{label}</BreadcrumbPage>
        </BreadcrumbItem>
      );
    }
  }
}

interface IAppBreadcrumbProps {
  items: TBreadcrumb[];
}

export function AppBreadcrumb({ items }: IAppBreadcrumbProps) {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {items.map((item, index) => (
          <Fragment key={item.id}>
            <BreadCrumbListItem key={item.id} item={item} />
            {index < items.length - 1 && <BreadcrumbSeparator />}
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
